import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from './_shared/shared.module';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { HomeComponent } from './home/home.component';
import { AuthReturnComponent } from './auth/auth-return/auth-return.component';
import { AuthUnauthorizedComponent } from './auth/auth-unauthorized/auth-unauthorized.component';
import { AuthorizeInterceptor } from './_core/interceptors/authorize.interceptor';
import { ErrorInterceptor } from './_core/interceptors/error.interceptor';
import { ForwardLinkComponent } from './forward-link/forward-link.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    //console.log('url=' + url);

    const firstPart = url.substring(0, url.indexOf('?')) || url;
    if (firstPart == url) {
      return super.parse(url.toLowerCase());
    }

    const lastPart = url.substring(url.indexOf('?'), url.length);
    // console.log('first part=' + firstPart);
    // console.log('last part=' + lastPart);

    const newURL = firstPart.toLowerCase() + lastPart;
    //console.log('new url=' + newURL);
      // Optional Step: Do some stuff with the url if needed.

      // If you lower it in the optional step
      // you don't need to use "toLowerCase"
      // when you pass it down to the next function
      return super.parse(newURL);
  }
}

@NgModule({
  declarations: [
    AppComponent,
    MaintenanceComponent,
    HomeComponent,
    AuthReturnComponent,
    AuthUnauthorizedComponent,
    ForwardLinkComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FontAwesomeModule,
    NgbModule,
    SharedModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthorizeInterceptor, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: UrlSerializer,
      useClass: LowerCaseUrlSerializer
  }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
